
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.498 4.834a4.224 4.224 0 00-3.637 2.08L4.17 5.325a1.963 1.963 0 000-.679l3.78-1.63c.305.374.769.612 1.286.612a1.66 1.66 0 001.66-1.658A1.66 1.66 0 009.235.31a1.66 1.66 0 00-1.644 1.875l-3.78 1.63a1.959 1.959 0 00-3.533 1.17 1.959 1.959 0 003.532 1.17l3.676 1.584a4.227 4.227 0 004.012 5.54 4.227 4.227 0 004.222-4.223 4.227 4.227 0 00-4.223-4.222zm-2.261-3.62a.755.755 0 11-.002 1.51.755.755 0 01.002-1.51zM2.24 6.04a1.057 1.057 0 010-2.111 1.057 1.057 0 010 2.111zm7.6 5.888v-.007a1.66 1.66 0 011.658-1.659 1.66 1.66 0 011.66 1.66v.006a3.297 3.297 0 01-1.66.445c-.603 0-1.17-.162-1.658-.445zm.904-3.324a.755.755 0 011.508 0 .755.755 0 01-1.508 0zm3.231 2.657a2.573 2.573 0 00-1.222-1.574c.251-.291.404-.67.404-1.083a1.66 1.66 0 00-1.659-1.66 1.66 1.66 0 00-1.658 1.66c0 .413.152.792.404 1.083-.595.335-1.043.9-1.222 1.574a3.304 3.304 0 01-.841-2.205 3.321 3.321 0 013.317-3.317 3.321 3.321 0 013.318 3.317c0 .845-.318 1.618-.84 2.205z","fill":"#B3B3B3"}})])
          )
        }
      }
    